module.exports = __webpack_public_path__ + "img/download_b.b6e2c5db.svg";